import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesSecurityEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-security-edit',
	path: '/secure/admin/EditIssueSecurities([!%]?[\\w]*).jspa',
};
